// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn.is-expanded .v-icon[data-v-0ce05803] {\n  transform: rotate(-180deg);\n}\n.border-right[data-v-0ce05803] {\n  border-right: 1px solid #688491;\n}", ""]);
// Exports
module.exports = exports;
